import cx from 'classnames';
import { FC, PropsWithChildren } from 'react';
import { LinkProps } from './types';
import styles from './Link.module.scss'

export const Link: FC<PropsWithChildren<LinkProps>> = ({
    className,
    handleClick,
    variant,
    href,
    children,
    noPadding,
    slot = '',
    target
}) => {
    const componentClassName = cx(styles['text-link'], className, {
        [`${styles['text-link--with-padding']}`]: !noPadding,
        [`${styles['f-12']}`]: variant === 'small'
      });

  return (
    <a
      className={componentClassName}
      href={href}
      onClick={handleClick}
      slot={slot}
      target={target}
    >
      {children}
    </a>
  );
};
